import { createSlice } from '@reduxjs/toolkit';
import { submitCategoryProgram } from './Utils/CategoryProgramUtils';

const initialState = {
  name: '',
  slug: '',
  children: [{ name: '', slug: '', parent_id: 1 }],
  isUpdate: false,
  id: '',
  isLoading: false
};

const addCategoryProgram = createSlice(
  {
    name: 'addCategoryProgram',
    initialState: initialState,
    reducers: {
      setField: (state, action) => {
        const { field, value } = action.payload;
        state[field] = value;
      },
      resetState: (state) => {
        return initialState;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(submitCategoryProgram.pending, (state) => {
          // Handle loading state
          state.isLoading = true;
        })
        .addCase(submitCategoryProgram.fulfilled, (state, action) => {
          // Handle success state
          console.log('Sukses:', action.payload);
          // return initialState;
          state.isLoading = false;
        })
        .addCase(submitCategoryProgram.rejected, (state, action) => {
          // Handle error state
          console.log('rejected', action.error);
          state.isLoading = false;
        });
    }
  }
);


export const { setField, resetState } = addCategoryProgram.actions;

export default addCategoryProgram.reducer;